import { memo } from 'react'
import { modalStore } from '@core/modal'
import { useValues } from '@core/store'

import { DIALOG_CONTAINERS, isGlobalDialog } from './dialogContainers'

export const ModalHost = memo(() => {
    const [activeDialog] = useValues([modalStore.props.getActiveDialog])

    if (!isGlobalDialog(activeDialog)) {
        return null
    }

    const DialogContainer = DIALOG_CONTAINERS[activeDialog]

    return <DialogContainer />
})
